export default "__VITE_ASSET__e7cabd23__"